/**
 * Membership annual tiers by market: the once / twice / quarterly blood
 * cadence prices. A new market is one new line here.
 *
 * The feed serves these per rhythm for the membership-first site
 * (`membershipTierAmount`, docs/pricing-sources.md); this module stays the
 * single static source behind its CHF fallback (`MEMBERSHIP_TIER_DEFAULT_CHF`)
 * and every flag-off surface, so no copy of the figures lives anywhere else.
 */

import type { Country } from "@/i18n/config"

export type MembershipTiers = {
  currency: "CHF" | "EUR"
  once: number
  twice: number
  quarterly: number
}

const MEMBERSHIP_TIERS: Partial<Record<Country, MembershipTiers>> = {
  ch: { currency: "CHF", once: 299, twice: 499, quarterly: 899 },
}

/** null = no membership price in this market: hide the price, don't relabel it. */
export function membershipTiers(country: string): MembershipTiers | null {
  return MEMBERSHIP_TIERS[country as Country] ?? null
}
